export default {
  title: 'green',

  twitter: '#17bf63',
  twitter_dark_hover: 'rgba(23, 191, 99, .1)',
  twitter_light_hover: '#15ac59',
}